<template>
  <div>
    <div id="mapChart" style="z-index:99" class="chart"></div>
    <div id="mapChartButtom" class="chart"></div>
  </div>
</template>

<script>
import echarts from "echarts";
import "echarts-gl";
import cityMap from "@/js/china-main-city-map.js";
import "echarts/map/js/china.js";
import "echarts/map/js/province/shanxi1.js";

export default {
  name: "chart",
  components: {
    // vHome
  },
  data() {
    return {
      chart: null,
      kuang_src: require("../../assets/kuang_10.png"),
      xianOption: {
        // 进行相关配置
        backgroundColor: "rgba(0,0,0,0)",
        // backgroundColor: "#ffffff",
        tooltip: {
          padding: 0,
          backgroundColor: "rgba(255,255,255,0)",
          textStyle: {
            color: "black"
          },
          position: [20, 260],
          formatter: params => {
            let tipHtml = `<div>
            <img src="${this.kuang_src}" width="200">
            <div style="position:absolute;top:30px;left:20px;color:#fff">${params.data.tipData}</div>
            </div>`;

            if (params.data.name && params.data.name.includes("市")) {
              return null;
            }
            return tipHtml;
          }
        }, // 鼠标移到图里面的浮动提示框
        geo: {
          // 这个是重点配置区
          map: "陕西", // 表示中国地图
          zoom: 1.1,
          aspectScale: 0.8,
          roam: false,
          label: {
            normal: {
              show: true, // 是否显示对应地名
              textStyle: {
                color: "rgba(255,255,255)"
              }
            },
            emphasis: {
              textStyle: {
                color: "rgba(255,255,255)"
              }
            }
          },
          top: 20,
          itemStyle: {
            normal: {
              // borderColor: "rgba(255, 255, 255, 0.5)",
              areaColor: "#008dff",
              borderColor: "#1accfc",
              borderWidth: 1
            },
            emphasis: {
              areaColor: "#0d4887",
              shadowOffsetX: 0,
              shadowOffsetY: 0,
              shadowBlur: 20,
              borderWidth: 1.25,
              borderColor: "#01cfff",
              shadowColor: "rgba(0, 0, 0, 0.5)"
            }
          }
        },
        series: [
          {
            name: "救援基地",
            type: "scatter",
            coordinateSystem: "geo", // 对应上方配置
            data: [
              {
                name: "",
                value: [108.945315, 34.338685],
                tipData: "此设备异常"
              },
              {
                name: "",
                value: [108.979608,34.916582],
                tipData: "此设备异常"
              },
              {
                name: "",
                value: [107.14487,34.369315],
                tipData: "此设备异常"
              },
              {
                name: "",
                value: [108.457859,34.80915],
                tipData: "此设备异常"
              },
              {
                name: "",
                value: [109.921334,34.768028],
                tipData: "此设备异常"
              },
              {
                name: "",
                value: [109.49081,36.596537],
                tipData: "此设备异常"
              },
              {
                name: "",
                value: [107.028621,33.077668],
                tipData: "此设备异常"
              },
              {
                name: "",
                value: [109.741193,38.290162],
                tipData: "此设备异常"
              },
              {
                name: "",
                value: [109.029273,32.6903],
                tipData: "此设备异常"
              },
              {
                name: "",
                value: [109.939776,33.868319],
                tipData: "此设备异常"
              },
            ],
            symbolSize: 15,
            symbol: "image://" + require("../../assets/dian_jg.png"),

            symbolRotate: 1,
            itemStyle: {
              normal: {
                color: "red"
              },
              emphasis: {
                color: "red"
              }
            },
            label: {
              normal: {
                formatter: "{b}",
                position: "right",
                show: false
              },
              emphasis: {
                show: true
              }
            }
          },
          {
            name: "启动次数", // 浮动框的标题
            type: "map",
            geoIndex: 0,
            data: [
              {
                name: "榆林市",
                tipData: "榆林市"
              },
              {
                name: "铜川市",
                tipData: "榆林市"
                // value: 0
              },
              {
                name: "渭南市",
                tipData: "榆林市"
                // value: 0
              },
              {
                name: "咸阳市",
                tipData: "榆林市"
                // value: 0
              },
              {
                name: "西安市",
                tipData: "榆林市"
                // value: 0
              },
              {
                name: "宝鸡市",
                tipData: "榆林市"
                // value: 0
              },
              {
                name: "延安市",
                tipData: "此设备压力过低注意排查"
              },
              {
                name: "商洛市",
                tipData: "此设备压力过低注意排查"
              },
              {
                name: "汉中市",
                tipData: "此设备压力过低注意排查"
              },
              {
                name: "安康市",
                tipData: "此设备压力过低注意排查"
              }
            ]
          }
        ]
      },
      xianOptionButtom: {
        //阴影地图
        // 进行相关配置
        backgroundColor: "rgba(0,0,0,0)",
        geo: {
          // 这个是重点配置区
          map: "陕西", // 表示中国地图
          zoom: 1.1,
          aspectScale: 0.8,
          roam: false,
          itemStyle: {
            normal: {
              borderColor: "#1a6095",
              areaColor: "#1a6095",
              borderWidth: 1
            },
            top: 10,
            emphasis: {
              areaColor: null,
              shadowOffsetX: 0,
              shadowOffsetY: 0,
              shadowBlur: 20,
              borderWidth: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)"
            }
          }
        }
      },
      xian2Option: {
        series: [
          {
            type: "map3D",
            name: "陕西",
            selectedMode: "single", //地图高亮单选
            boxDepth: 210, //地图倾斜度
            regionHeight: 5, //地图高度
            map: "陕西",
            viewControl: {
              distance: 280, //地图视角 控制初始大小
              rotateSensitivity: [1, 1],
              // rotateSensitivity: 1, //禁止旋转
              zoomSensitivity: 1 //禁止缩放
            },
            label: {
              show: true, //是否显示市
              textStyle: {
                color: "#0a1640", //文字颜色
                fontSize: 12, //文字大小
                backgroundColor: "rgba(0,0,0,0)" //透明度0清空文字背景
              }
            },
            itemStyle: {
              color: "rgba(0, 141, 255, 1)", //地图颜色
              borderWidth: 1, //分界线wdith
              borderColor: "rgba(255, 255, 255, 0.5)", //分界线颜色
              areaColor: "rgba(0, 141, 255, 1)"
              // borderColor: "#1dc199",
            },
            emphasis: {
              label: {
                show: true, //是否显示高亮
                textStyle: {
                  color: "#fff" //高亮文字颜色
                }
              },
              itemStyle: {
                color: "#0489d6" //地图高亮颜色
              }
            },
            //高亮市区  echarts  bug 不生效
            regions: [
              {
                name: "宜昌市",
                itemStyle: {
                  areaColor: "#f00"
                }
              }
            ]
          }
        ]
      }
    };
  },
  mounted() {
    this.chinaConfigure();
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    chinaConfigure() {
      let mapChartButtom = echarts.init(
        document.getElementById("mapChartButtom")
      );
      mapChartButtom.setOption(this.xianOptionButtom);
      let myChart = echarts.init(document.getElementById("mapChart")); //这里是为了获得容器所在位置
      // window.onresize = () => {
      //   myChart.resize();
      //   mapChartButtom.resize();
      // };
      // myChart.setOption({
      //   // 进行相关配置
      //   backgroundColor: "rgba(0,0,0,0)",
      //   tooltip: {}, // 鼠标移到图里面的浮动提示框
      //   dataRange: {
      //     show: false,
      //     min: 0,
      //     max: 1000,
      //     text: ["High", "Low"],
      //     realtime: true,
      //     calculable: true,
      //     color: ["orangered", "yellow", "lightskyblue"]
      //   },
      //   geo: {
      //     // 这个是重点配置区
      //     map: "china", // 表示中国地图
      //     roam: true,
      //     label: {
      //       normal: {
      //         show: true, // 是否显示对应地名
      //         textStyle: {
      //           color: "rgba(0,0,0,0.4)"
      //         }
      //       }
      //     },
      //     itemStyle: {
      //       normal: {
      //         //   borderColor: 'rgba(0, 0, 0, 0.2)'
      //         // areaColor: "rgba(23, 27, 57,0)",
      //         areaColor: "rgba(0, 141, 255, 1)",
      //         borderColor: "#1dc199",
      //         borderWidth: 1
      //       },
      //       emphasis: {
      //         areaColor: null,
      //         shadowOffsetX: 0,
      //         shadowOffsetY: 0,
      //         shadowBlur: 20,
      //         borderWidth: 0,
      //         shadowColor: "rgba(0, 0, 0, 0.5)"
      //       }
      //     }
      //   },
      //   series: [
      //     {
      //       type: "scatter",
      //       coordinateSystem: "geo" // 对应上方配置
      //     },
      //     {
      //       name: "启动次数", // 浮动框的标题
      //       type: "map",
      //       geoIndex: 0,
      //       data: [
      //         //   {
      //         //   "name": "北京",
      //         //   "value": 599
      //         // }, {
      //         //   "name": "上海",
      //         //   "value": 142
      //         // }, {
      //         //   "name": "黑龙江",
      //         //   "value": 44
      //         // }, {
      //         //   "name": "深圳",
      //         //   "value": 92
      //         // }, {
      //         //   "name": "湖北",
      //         //   "value": 810
      //         // }, {
      //         //   "name": "四川",
      //         //   "value": 453
      //         // }
      //         {
      //           name: "陕西",
      //           value: 900
      //         }
      //       ]
      //     }
      //   ]
      // });
      let that = this;

      myChart.setOption(that.xianOption);

      myChart.on("click", function(param) {
        // alert(param.code);
        if (param.name == "陕西") {
          myChart.setOption(this.xianOption);
        } else {
        }
      });
    }
  }
};
</script>

<style scoped>
.chart {
  width: 100%;
  height: 69vh;
}

#mapChartButtom {
  z-index: -200;
  position: absolute;
  top: -10px;
  left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/chinaMap.vue